import userItemConnector from "../user-item-connector"

import UserEditItem from "./UserEditItem"

export default userItemConnector(UserEditItem)
